import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { IAvailableProgramExecutionGroupQuery, IAvailableProgramExecutionImageQuery } from '../interfaces/available-program-execution-group.query.interface';
import { RelevantExecutionRuleEnum } from '../enums/relevant-execution-rule.enum';
import { CourseExecutionProgramExecution } from './course-execution-program-execution.model';

export class AvailableProgramExecutionGroup {
    id: string;
    name: string;
    image: MaxbrainImage | null;
    executions: CourseExecutionProgramExecution[];
    expanded = true;

    constructor(query: IAvailableProgramExecutionGroupQuery) {
        const offering = query.program_offering;
        const templateImage = offering?.course_template?.image || null;

        this.id = offering ? offering.id.toString() : '';
        this.name = offering?.name || '';
        this.image = this._mapImage(templateImage);
        this.executions = (query.executions || []).map(
            (execution) =>
                new CourseExecutionProgramExecution({
                    id: execution.id,
                    name: execution.name,
                    start_date: null,
                    end_date: null,
                    status: '',
                    is_default: false,
                    relevant_execution_rule: RelevantExecutionRuleEnum.MANUALLY_ADD_EXECUTIONS,
                    self_paced: !!execution.self_paced,
                    image: this._toImageQuery(execution.image),
                    course_offering: offering
                        ? {
                              id: offering.id,
                              name: offering.name,
                          }
                        : null,
                    category: null,
                })
        );
    }

    private _mapImage(image: IAvailableProgramExecutionImageQuery | null): MaxbrainImage | null {
        const imageQuery = this._toImageQuery(image);

        return imageQuery ? new MaxbrainImage(imageQuery) : null;
    }

    private _toImageQuery(image: IAvailableProgramExecutionImageQuery | null) {
        if (!image?.thumb_url && !image?.url) {
            return null;
        }

        return {
            id: image.id?.toString() || '',
            url: image.url || '',
            small_url: image.small_url || '',
            thumb_url: image.thumb_url || '',
            large_url: image.large_url || '',
            unsplash: {
                unsplash_id: '',
                author_name: '',
                author_profile_url: '',
                author_profile_image: '',
            },
        };
    }
}
